module.exports = __webpack_public_path__ + "img/sun-lower.e268ea70.svg";